<script setup lang="ts">
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import { FireOutbreakReactionOptionsFactory } from '../factories/FireOutbreakReactionOptions.factory'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import { computed } from 'vue'

const props = withDefaults(
	defineProps<{
		alert: FireOutbreak
		paintIcon?: boolean
	}>(),
	{
		paintIcon: true,
	},
)

const emit = defineEmits<{
	(event: 'reaction', value: FireOutbreakReactionEnum): void
}>()

const icon = computed(() => {
	switch (props.alert.reaction) {
		case FireOutbreakReactionEnum.POSITIVE:
			return 'material-symbols:thumb-up-rounded'
		case FireOutbreakReactionEnum.NEGATIVE:
			return 'material-symbols:thumb-down-rounded'
		case FireOutbreakReactionEnum.IMPOSSIBLE:
			return 'fa7-solid:question'
		default:
			return 'material-symbols:thumb-up-outline-rounded'
	}
})

const iconColor = computed(() => {
	if (!props.paintIcon) return 'text-blue-base'
	return props.alert.seen ? 'text-blue-base' : 'text-red-danger'
})
</script>

<template>
	<context-menu
		:options="FireOutbreakReactionOptionsFactory.make(alert.reaction)"
		:icon="icon"
		:icon-color="iconColor"
		@change="emit('reaction', $event)"
	/>
</template>
